import { render, staticRenderFns } from "./TotalDepositAndWithdrawalStatusTable.vue?vue&type=template&id=d80e694a&scoped=true&"
import script from "./TotalDepositAndWithdrawalStatusTable.vue?vue&type=script&lang=js&"
export * from "./TotalDepositAndWithdrawalStatusTable.vue?vue&type=script&lang=js&"
import style0 from "./TotalDepositAndWithdrawalStatusTable.vue?vue&type=style&index=0&id=d80e694a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d80e694a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
